/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseEmailTemplate = {
    EmailFieldVerification: 'EMAIL_FIELD_VERIFICATION',
    EmailFieldUnsubscribed: 'EMAIL_FIELD_UNSUBSCRIBED',
    DateFieldSimpleReminderTemplate: 'DATE_FIELD_SIMPLE_REMINDER_TEMPLATE',
    DateFieldEcardTemplate: 'DATE_FIELD_ECARD_TEMPLATE',
    DateFieldBusinessCardTemplate: 'DATE_FIELD_BUSINESS_CARD_TEMPLATE',
    SendLinkToEntry: 'SEND_LINK_TO_ENTRY',
    DatabaseInvite: 'DATABASE_INVITE',
    MailOnNewEntry: 'MAIL_ON_NEW_ENTRY',
    MailOnNewComment: 'MAIL_ON_NEW_COMMENT'
} as const;
export type DatabaseEmailTemplate = typeof DatabaseEmailTemplate[keyof typeof DatabaseEmailTemplate];


export function DatabaseEmailTemplateFromJSON(json: any): DatabaseEmailTemplate {
    return DatabaseEmailTemplateFromJSONTyped(json, false);
}

export function DatabaseEmailTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEmailTemplate {
    return json as DatabaseEmailTemplate;
}

export function DatabaseEmailTemplateToJSON(value?: DatabaseEmailTemplate | null): any {
    return value as any;
}

